"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProviderCardsStore = void 0;
var vuex_1 = require("vuex");
var vue_1 = require("vue");
var pinia_1 = require("pinia");
var apis_1 = require("@/constants/apis");
console.log("Initializing Pinia");
var axios_1 = require("axios");
var privilegesApi_1 = require("@/api/privilegesApi");
var messagingSender_1 = require("@/utils/messagingSender");
// Generate avatar color from name
function generateAvatarColor(name) {
    var colors = [
        '#3b82f6', '#10b981', '#f59e0b', '#ef4444', '#8b5cf6',
        '#ec4899', '#06b6d4', '#84cc16', '#f97316', '#6366f1'
    ];
    var hash = 0;
    for (var i = 0; i < name.length; i++) {
        hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    return colors[Math.abs(hash) % colors.length];
}
exports.useProviderCardsStore = (0, pinia_1.defineStore)('providerCards', function () {
    console.log("ProviderCard Store Initialized");
    // Vuex store access MUST happen at runtime (inside this function), not at module import
    var vuex = (0, vuex_1.useStore)();
    var allData = (0, vue_1.computed)(function () {
        // guard in case vuex or getters are missing during early startup
        return vuex && vuex.getters ? vuex.getters['login/getAllData'] : { manager: {}, patient: {} };
    });
    var staffContext = (0, vue_1.computed)(function () {
        var _a = (0, privilegesApi_1.resolveKeyonPrivilegeIdentity)(allData.value), accountnumber = _a.accountnumber, unique_ID = _a.unique_ID;
        return { externId: unique_ID, externId2: accountnumber };
    });
    //IN this instance the current Provider could be the Provider themself | so if they select their own card - could create an Edge Case
    // The compose modals' "From" and a call's `from`. Empty until the session
    // is known: the placeholder clinician that used to sit here was offered as
    // the caller, and a call sent its number as `from`.
    var currentProvider = (0, vue_1.ref)({
        id: '',
        name: '',
        email: '',
        phone: '',
        specialty: ''
    });
    /**
     * The signed-in person — the staff member, not the patient, while charting
     * (utils/messagingSender.js). Set before the roster loads because it does
     * not depend on it: a roster that is empty, still arriving or failed must not
     * leave the previous or a fictitious sender on the From line.
     */
    function refreshSender() {
        try {
            currentProvider.value = (0, messagingSender_1.messagingSender)(allData.value);
        }
        catch (e) {
            // No session blob yet; the next load sets it.
        }
    }
    var patprovider = (0, vue_1.ref)([]);
    /*const nurses = ref<Nurses[]>([
      {
        id: 'pt-001',
        pmid: 1,
        accountnumber: '960059770',
        subaccountnumber: '958344783',
        firstName: 'James',
        lastName: 'Anderson',
        dateOfBirth: '1985-03-15',
        socnum: '123-45-6789',
        email: 'james.anderson@email.com',
        phone: '(555) 234-5678',
        address: { street: '123 Oak Street', street2:'', city: 'Springfield', state: 'IL', zip: '62701' },
        fax:'31775000',
        npinumber: 'ARN-100234',
        avatarColor: generateAvatarColor('James Anderson'),
        tags: ['Diabetes', 'Hypertension'],
        activeStatus:'Active',
        providerStatus:'Active',
        nextVisit:'06-10-2026',
        lastvisit:'06-10-12,
        onTeam:1
      },
     
      {
        id: 'pt-002',
       providerid: 2,
        accountnumber: '960059770',
        subaccountnumber: '958344783',
        firstName: 'James',
        lastName: 'Anderson',
        dateOfBirth: '1985-03-15',
        socnum: '123-45-6789',
        email: 'james.anderson@email.com',
        phone: '(555) 234-5678',
        address: { street: '123 Oak Street', street2:'', city: 'Springfield', state: 'IL', zip: '62701' },
        fax:'31775000',
        npinumber: 'ARN-100234',
        avatarColor: generateAvatarColor('James Anderson'),
        tags: ['Diabetes', 'Hypertension'],
        activeStatus:'Active',
        providerStatus:'Active',
        nextVisit:'06-10-2026',
        lastvisit:'06-10-12,
        onTeam:1
      },
      {
        id: 'pt-003',
       providerid: 3,
        accountnumber: '960059770',
        subaccountnumber: '958344783',
        firstName: 'James',
        lastName: 'Anderson',
        dateOfBirth: '1985-03-15',
        socnum: '123-45-6789',
        email: 'james.anderson@email.com',
        phone: '(555) 234-5678',
        address: { street: '123 Oak Street', street2:'', city: 'Springfield', state: 'IL', zip: '62701' },
        fax:'31775000',
        npinumber: 'ARN-100234',
        avatarColor: generateAvatarColor('James Anderson'),
        tags: ['Diabetes', 'Hypertension'],
        activeStatus:'Active',
        providerStatus:'Active',
        nextVisit:'06-10-2026',
        lastvisit:'06-10-12,
        onTeam:1
      },
      {
        id: 'pt-004',
        providerid: 4,
        accountnumber: '960059773',
        psersonalID: '958344786',
        firstName: 'Emily',
        lastName: 'Davis',
        email: 'emily.davis@email.com',
        phone: '(555) 567-8901',
        address: { street: '321 Elm Street', city: 'Oak Park', state: 'IL', zip: '60301' },
        dateOfBirth: '1988-05-30',
        gender: 'Female',
        socnum: '456-78-9012',
        emergency_contactn: 'John Davis',
        matial_status: 'Married',
        insuranceProvider: 'Cigna',
        mrn: 'MRN-100237',
        lastVisit: '2026-03-20',
        nextAppointment: '2026-04-22',
        avatarColor: generateAvatarColor('Emily Davis'),
        tags: ['Pregnancy', 'Prenatal']
      },
      {
        id: 'pt-005',
        pid: 5,
        accountnumber: '960059774',
        psersonalID: '958344787',
        firstName: 'Michael',
        lastName: 'Wilson',
        email: 'michael.wilson@email.com',
        phone: '(555) 678-9012',
        address: { street: '654 Cedar Lane', city: 'Naperville', state: 'IL', zip: '60540' },
        dateOfBirth: '1965-09-12',
        gender: 'Male',
        socnum: '567-89-0123',
        emergency_contactn: 'Susan Wilson',
        matial_status: 'Married',
        insuranceProvider: 'Medicare',
        mrn: 'MRN-100238',
        lastVisit: '2026-04-02',
        nextAppointment: '2026-05-01',
        avatarColor: generateAvatarColor('Michael Wilson'),
        tags: ['Heart Disease', 'Diabetes', 'Hypertension']
      },
      {
        id: 'pt-006',
        pid: 6,
        accountnumber: '960059775',
        psersonalID: '958344788',
        firstName: 'Sarah',
        lastName: 'Thompson',
        email: 'sarah.thompson@email.com',
        phone: '(555) 789-0123',
        address: { street: '987 Birch Road', city: 'Schaumburg', state: 'IL', zip: '60173' },
        dateOfBirth: '1995-01-25',
        gender: 'Female',
        socnum: '678-90-1234',
        emergency_contactn: 'Tom Thompson',
        matial_status: 'Single',
        insuranceProvider: 'Blue Cross Blue Shield',
        mrn: 'MRN-100239',
        lastVisit: '2026-03-15',
        avatarColor: generateAvatarColor('Sarah Thompson'),
        tags: ['Migraines']
      },
      {
        id: 'pt-007',
        pid: 7,
        accountnumber: '960059776',
        psersonalID: '958344789',
        firstName: 'David',
        lastName: 'Martinez',
        email: 'david.martinez@email.com',
        phone: '(555) 890-1234',
        address: { street: '147 Walnut Street', city: 'Aurora', state: 'IL', zip: '60502' },
        dateOfBirth: '1978-12-03',
        gender: 'Male',
        socnum: '789-01-2345',
        emergency_contactn: 'Ana Martinez',
        matial_status: 'Married',
        insuranceProvider: 'Humana',
        mrn: 'MRN-100240',
        lastVisit: '2026-04-08',
        nextAppointment: '2026-04-25',
        avatarColor: generateAvatarColor('David Martinez'),
        tags: ['Back Pain', 'Physical Therapy']
      },
      {
        id: 'pt-008',
        pid: 8,
        accountnumber: '960059777',
        psersonalID: '958344790',
        firstName: 'Jennifer',
        lastName: 'Brown',
        email: 'jennifer.brown@email.com',
        phone: '(555) 901-2345',
        address: { street: '258 Spruce Court', city: 'Joliet', state: 'IL', zip: '60431' },
        dateOfBirth: '1982-06-18',
        gender: 'Female',
        socnum: '890-12-3456',
        emergency_contactn: 'Mike Brown',
        matial_status: 'Married',
        insuranceProvider: 'Aetna',
        mrn: 'MRN-100241',
        lastVisit: '2026-03-30',
        nextAppointment: '2026-04-18',
        avatarColor: generateAvatarColor('Jennifer Brown'),
        tags: ['Thyroid', 'Annual Checkup']
      }
    ])*/
    var searchQuery = (0, vue_1.ref)('');
    var filterTag = (0, vue_1.ref)(null);
    var sortBy = (0, vue_1.ref)('Firstname');
    // Get all unique tags
    var allTags = (0, vue_1.computed)(function () {
        var tags = new Set();
        patprovider.value.forEach(function (p) { return p.tags.forEach(function (t) { return tags.add(t); }); });
        return Array.from(tags).sort();
    });
    // Filtered and sorted patients
    var filteredProviders = (0, vue_1.computed)(function () {
        var result = __spreadArray([], patprovider.value, true);
        // Search filter
        if (searchQuery.value.trim()) {
            var query_1 = searchQuery.value.toLowerCase();
            result = result.filter(function (p) {
                return p.firstName.toLowerCase().includes(query_1) ||
                    p.lastName.toLowerCase().includes(query_1) ||
                    p.email.toLowerCase().includes(query_1) ||
                    p.phone.includes(query_1) ||
                    p.arn.toLowerCase().includes(query_1);
            });
        }
        // Tag filter
        if (filterTag.value) {
            result = result.filter(function (p) { return p.tags.includes(filterTag.value); });
        }
        // Sort
        result.sort(function (a, b) {
            if (sortBy.value === 'Firstname') {
                return "".concat(a.lastName, " ").concat(a.firstName).localeCompare("".concat(b.lastName, " ").concat(b.firstName));
            }
            else if (sortBy.value === 'Lastname') {
                return (b.npinumber || '').localeCompare(a.lastName || '');
            }
            else {
                return (a.status || 'z').localeCompare(b.npinumber || 'z');
            }
        });
        return result;
    });
    function updateProviders(id, updates) {
        var index = patprovider.value.findIndex(function (p) { return p.id === id; });
        if (index !== -1) {
            patprovider.value[index] = __assign(__assign({}, patprovider.value[index]), updates);
        }
    }
    function getProviderById(id) {
        return patprovider.value.find(function (p) { return p.id === id; });
    }
    function setSearchQuery(query) {
        searchQuery.value = query;
    }
    function setFilterTag(tag) {
        filterTag.value = tag;
    }
    function setSortBy(sort) {
        sortBy.value = sort;
    }
    //Axios Update Patients | Don't forget to Export this function for access
    /** Returns true on confirmed success. On success, patches the local
     * patprovider entry with `updates` so the card re-renders with the new
     * values immediately - no tab switch/reload needed to see the change. */
    function axiosUpdateProvider(id, updates) {
        return __awaiter(this, void 0, Promise, function () {
            var index, providerId, content, res, e_1;
            var _a, _b, _c, _d, _e, _f, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        index = patprovider.value.findIndex(function (p) { return p.id === id; });
                        if (index === -1)
                            return [2 /*return*/, false];
                        providerId = id;
                        content = {
                            Provider: {
                                API_Meth: "UpdatePatientProvidersGroupAccountUser",
                                accountnumber: allData.value.manager.externid2,
                                patient_unique_ID: allData.value.patient.externId,
                                member_unique_ID: providerId,
                                firstname: updates.firstName,
                                lastname: updates.lastName,
                                address: (_a = updates.address) === null || _a === void 0 ? void 0 : _a.street, //address1,
                                city: (_b = updates.address) === null || _b === void 0 ? void 0 : _b.city,
                                state: (_c = updates.address) === null || _c === void 0 ? void 0 : _c.state,
                                zip: (_d = updates.address) === null || _d === void 0 ? void 0 : _d.zip,
                                phone: updates.phone,
                                cell: updates.mobile,
                                email: updates.email,
                                npinumber: updates.npinumber,
                            },
                        };
                        _h.label = 1;
                    case 1:
                        _h.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios_1.default.post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })];
                    case 2:
                        res = _h.sent();
                        if (((_e = res.data) === null || _e === void 0 ? void 0 : _e.msg) === "Updated") {
                            patprovider.value[index] = __assign(__assign({}, patprovider.value[index]), updates);
                            return [2 /*return*/, true];
                        }
                        console.error("axiosUpdateProvider failed:", ((_g = (_f = res.data) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g.ErrorMessage) || res.data);
                        return [2 /*return*/, false];
                    case 3:
                        e_1 = _h.sent();
                        console.error("axiosUpdateProvider request failed:", e_1);
                        return [2 /*return*/, false];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function loadAccountProviders() {
        return __awaiter(this, void 0, void 0, function () {
            var ctx, managerId, patientId, provaccount, content;
            var _a, _b, _c, _d, _e, _f, _g, _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        refreshSender();
                        ctx = staffContext.value;
                        if (!ctx.externId || !ctx.externId2) {
                            // fullPatientList.value = [];
                            patprovider.value = []; //I guess we are gong to say that the pateint list is here and that its empty if externId and externID2 is missing
                            return [2 /*return*/];
                        }
                        patprovider.value = [];
                        managerId = (_b = (_a = allData.value) === null || _a === void 0 ? void 0 : _a.manager) === null || _b === void 0 ? void 0 : _b.externId;
                        patientId = (_d = (_c = allData.value) === null || _c === void 0 ? void 0 : _c.patient) === null || _d === void 0 ? void 0 : _d.externId;
                        provaccount = (_f = (_e = allData.value) === null || _e === void 0 ? void 0 : _e.manager) === null || _f === void 0 ? void 0 : _f.externId2;
                        console.log("Pina Store All Data");
                        console.log(allData);
                        console.log((_g = allData.value) === null || _g === void 0 ? void 0 : _g.manager);
                        console.log("PatientID Search");
                        console.log((_h = allData.value) === null || _h === void 0 ? void 0 : _h.patient);
                        content = {
                            Provider: {
                                API_Meth: "GetProvidersFromPatientProvidersGroup",
                                accountnumber: ctx.externId2,
                                patient_unique_ID: patientId
                            }
                        };
                        return [4 /*yield*/, axios_1.default
                                .post(apis_1.CURR_API + "/tswebhook.php", content, {
                                headers: { "Content-Type": "application/json;" },
                            })
                                .then(function (res) {
                                console.log("Providers Payload Response");
                                console.log(res.data.provider[0]);
                                var pts = res.data.provider && Array.isArray(res.data.provider) ? res.data.provider : [];
                                // Map and set PatientInfo
                                patprovider.value = pts.map(function (item) { return ({
                                    id: item.providerid, //'pt-006',
                                    providerid: item.member_unique_ID, //6,
                                    npinumber: item.npinumber,
                                    accountnumber: ctx.externId2, // '960059775',
                                    subaccountnumber: item.subaccountnumber,
                                    firstName: item.firstname, //'Sarah',
                                    lastName: item.lastname, //'Thompson',
                                    dateOfBirth: item.dob,
                                    socnum: item.socialnum,
                                    phone: item.tel,
                                    mobile: item.cell || '',
                                    email: item.email, //'sarah.thompson@email.com',
                                    address: { street: item.addr1, street2: '', city: item.city, state: item.state, zip: item.postalcode },
                                    status: 'Active',
                                    taxonomy: 'Generalist', // item.taxonomy,
                                    lastVisit: '2026-01-11', //item.last_visit,
                                    nextVisit: '2026-05-04', //item.next_visit,
                                    arn: 'AN-' + ctx.externId2, //100239',
                                    avatarColor: generateAvatarColor(item.firstname + " " + item.lastname),
                                    tags: ['Migraines'],
                                    // The licence scan and the insurance certificate. The API names the
                                    // file, so the card labels it with the real filename rather than
                                    // guessing from the URL as the legacy cards did.
                                    licenseFile: item.licenseFile,
                                    licenseDocName: item.licenseFileName || '',
                                    insuranceFile: item.insuranceFile,
                                    insuranceDocName: item.insuranceFileName || '',
                                }); });
                                console.log("Store Providers");
                                console.log(patprovider.value);
                                //now Set the Provider 
                                currentProvider.value = (0, messagingSender_1.messagingSender)(allData.value); // the signed-in person; the staff member, not the patient, while charting
                                //return patients;
                            })
                                .catch(function (err) {
                                console.log("GetPatient Error");
                                console.log(err);
                            })];
                    case 1:
                        _j.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    //function to return Document name
    /*function returnDocumentName(file:string):String
    {
      const docurl = file;
      const splitinfo = docurl.split("/");
      if(splitinfo[4].length >=1)
      {
        console.log("Document Return Name Attempt");
        console.log(splitinfo[5]);
        return splitinfo[5];
      }
      else{
        return ""
      }
     
    }*/
    return {
        currentProvider: currentProvider,
        patprovider: patprovider,
        searchQuery: searchQuery,
        filterTag: filterTag,
        sortBy: sortBy,
        allTags: allTags,
        filteredProviders: filteredProviders,
        updateProviders: updateProviders,
        getProviderById: getProviderById,
        setSearchQuery: setSearchQuery,
        setFilterTag: setFilterTag,
        setSortBy: setSortBy,
        loadAccountProviders: loadAccountProviders,
        axiosUpdateProvider: axiosUpdateProvider
    };
});
